import type { TouchEvent } from "react";
import { useCallback, useRef } from "react";

export const useHorizontalSwipe = (props: { onSwipeLeft?: () => void; onSwipeRight?: () => void; enabled?: boolean; thresholdPx?: number }) => {
  const { onSwipeLeft, onSwipeRight, enabled = true, thresholdPx = 50 } = props;

  const startXRef = useRef<number | null>(null);

  const onTouchStart = useCallback(
    (e: TouchEvent) => {
      if (!enabled) return;
      startXRef.current = e.touches[0].clientX;
    },
    [enabled],
  );

  const onTouchEnd = useCallback(
    (e: TouchEvent) => {
      if (!enabled || startXRef.current === null) return;

      const endX = e.changedTouches[0].clientX;
      const diff = startXRef.current - endX;

      if (Math.abs(diff) > thresholdPx) {
        if (diff > 0) {
          onSwipeLeft?.();
        } else {
          onSwipeRight?.();
        }
      }

      startXRef.current = null;
    },
    [enabled, onSwipeLeft, onSwipeRight, thresholdPx],
  );

  const clear = useCallback(() => {
    startXRef.current = null;
  }, []);

  return {
    onTouchStart,
    onTouchEnd,
    onTouchCancel: onTouchEnd,
    clear,
  };
};
